module.exports = __webpack_public_path__ + "static/media/soccer.a179299e.svg";